import { OwnerType } from "@/api/SolarCloudApi";

const choices = [
  { type: OwnerType.USER, title: "Private" },
  { type: OwnerType.ORGANISATION, title: "Organisation" },
];

type OwnerChoicesProps = {
  ownerType: OwnerType | undefined;
  setOwnerType: (type: OwnerType) => void;
};

export function OwnerChoices({ ownerType, setOwnerType }: OwnerChoicesProps) {
  return (
    <section className="flex flex-col gap-3">
      
      <div className="flex flex-col gap-3">
        {choices.map((choice) => {
          const isSelected = ownerType === choice.type;
          return (
            <label
              key={choice.type}
              className={`
                relative flex items-center justify-between p-4 rounded-xl border-2 transition-all duration-200 cursor-pointer
                ${isSelected 
                  ? "border-primary bg-primary/5 ring-1 ring-primary/20 shadow-sm" 
                  : "border-border hover:border-muted-foreground/30 bg-card hover:bg-accent/50"}
              `}
            >
              <div className="flex items-center gap-4">
                <div className={`
                  flex items-center justify-center w-5 h-5 rounded-full border-2 transition-all
                  ${isSelected ? "border-primary bg-primary" : "border-muted-foreground/30"}
                `}>
                  {isSelected && <div className="w-2 h-2 rounded-full bg-white" />}
                </div>
                <span className={`text-base font-semibold ${isSelected ? "text-foreground" : "text-muted-foreground"}`}>
                  {choice.title}
                </span>
              </div>
              <input
                type="radio"
                name="ownerType"
                value={String(choice.type)}
                checked={isSelected}
                onChange={() => setOwnerType(choice.type)}
                className="sr-only"
              />
            </label>
          );
        })}
      </div>
    </section>
  );
}
